import { css } from '@emotion/react'
import mq from '../styles/mediaQueries'

export const Headline1 = css`
  font-family: degular-display, sans-serif;
  font-style: normal;
  font-weight: normal;
  line-height: 100%;

  ${mq({
    fontSize: ['15vw', '10vw', '7.5vw', '7.5vw', '7.5vw'],
  })};
`
export const Headline2 = css`
  font-family: degular-display, sans-serif;
  font-style: normal;
  font-weight: 500;
  line-height: 100%;
  letter-spacing: 0.005em;

  ${mq({
    fontSize: ['12.5vw', '7.5vw', '5vw', '5vw', '5vw'],
  })};
`
export const Headline3 = css`
  font-family: degular-display, sans-serif;
  font-style: normal;
  font-weight: 500;
  letter-spacing: 0.01em;

  ${mq({
    fontSize: ['36px', '36px', '40px', '40px', '40px'],
    lineHeight: ['111.11%', '111.11%', '110%', '110%', '110%'],
  })};
`
export const Headline4 = css`
  font-family: degular-display, sans-serif;
  font-style: normal;
  font-weight: 500;
  letter-spacing: 0.015em;

  ${mq({
    fontSize: ['24px', '24px', '28px', '28px', '28px'],
    lineHeight: ['116.67%', '116.67%', '114.29%', '114.29%', '114.29%'],
  })};
`
export const Headline5 = css`
  font-family: degular-display, sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 120%;
  letter-spacing: 0.02em;
`
export const Headline6 = css`
  font-family: degular-display, sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 125%;
  letter-spacing: 0.025em;
`
export const Subheading1 = css`
  font-family: degular-display, sans-serif;
  font-style: normal;
  font-weight: normal;
  letter-spacing: 0.01em;

  ${mq({
    fontSize: ['32px', '32px', '40px', '40px', '40px'],
    lineHeight: ['137.5%', '137.5%', '130%', '130%', '130%'],
  })};
`
export const Subheading2 = css`
  font-family: degular-display, sans-serif;
  font-style: normal;
  font-weight: normal;
  letter-spacing: 0.015em;

  ${mq({
    fontSize: ['24px', '24px', '28px', '28px', '28px'],
    lineHeight: ['150%', '150%', '142.86%', '142.86%', '142.86%'],
  })};
`
export const Body1 = css`
  font-family: degular, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 160%;
`
export const Body2 = css`
  font-family: degular, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 150%;
  letter-spacing: 0.01em;
`
export const Mono = css`
  font-family: var(--mono-font-stack);
  font-style: normal;
  font-weight: normal;

  ${mq({
    fontSize: ['16px', '16px', '20px', '20px', '20px'],
    lineHeight: ['150%', '150%', '140%', '140%', '140%'],
  })};
`
export const Caption = css`
  font-family: degular, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 133.33%;
  letter-spacing: 0.02em;
`
